'use client';

import { useEffect } from 'react';
import { installNumberInputWheelGuard } from '@/lib/browser/number-input-wheel-guard';

/**
 * Mounted once in the root layout, so every page in the app (dashboard, Setup,
 * Admin, registration, hub) gets it: scrolling over a focused number field
 * blurs it instead of changing its value. See number-input-wheel-guard.ts.
 */
export function NumberInputWheelGuard() {
  useEffect(() => installNumberInputWheelGuard(document), []);
  return null;
}
